<div class="bg-white rounded-lg shadow-lg p-4 sm:p-6 lg:p-8 mx-auto">
  <!-- Header -->
  <div class="mb-4 sm:mb-6">
    <h3 class="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-800 text-center">
      {{ textHedaer }}
    </h3>
    <p class="text-xs sm:text-sm text-gray-600 text-center mt-1 sm:mt-2">
      Comparte tu experiencia con otros usuarios
    </p>
  </div>

  <!-- Form -->
  <form [formGroup]="commentForm" (ngSubmit)="onSubmit()" class="space-y-4 sm:space-y-6">
    <!-- Rating Section -->
    <div class="text-center">
      <label class="block text-sm sm:text-base font-medium text-gray-700 mb-2 sm:mb-3"
        >Calificación</label
      >
      <div class="flex justify-center space-x-1 sm:space-x-2 mb-2">
        @for (star of [1,2,3,4,5]; track star) {
        <button
          type="button"
          (click)="setRating(star)"
          class="text-xl sm:text-2xl lg:text-3xl star-button p-1 sm:p-2"
          [class.text-yellow-400]="star <= commentForm.get('starts')?.value"
          [class.text-gray-300]="star > commentForm.get('starts')?.value"
          [class.star-selected]="star <= commentForm.get('starts')?.value"
        >
          <i class="fas fa-star"></i>
        </button>
        }
      </div>
      <p class="text-xs sm:text-sm text-gray-500">
        Haz clic en las estrellas para calificar
      </p>
    </div>

    <!-- Comment Section -->
    <div>
      <label for="comment" class="block text-sm sm:text-base font-medium text-gray-700 mb-2">
        Comentario
      </label>
      <textarea
        id="comment"
        formControlName="comment"
        rows="3"
        class="sm:rows-4 lg:rows-5"
        placeholder="Escribe tu comentario aquí..."
        class="w-full px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 resize-none transition-colors duration-200"
        [class.border-red-500]="
          commentForm.get('comment')?.invalid &&
          commentForm.get('comment')?.touched
        "
      ></textarea>

      <!-- Error message for comment -->
      @if (commentForm.get('comment')?.invalid &&
      commentForm.get('comment')?.touched) {
      <div class="mt-1 text-xs sm:text-sm text-red-600">
        <i class="fas fa-exclamation-circle mr-1"></i>
        El comentario es requerido
      </div>
      }
    </div>

    <!-- Error message for rating -->
    @if (commentForm.get('starts')?.invalid &&
    commentForm.get('starts')?.touched) {
    <div class="text-xs sm:text-sm text-red-600 text-center">
      <i class="fas fa-exclamation-circle mr-1"></i>
      Por favor selecciona una calificación
    </div>
    }

    <!-- Submit Button -->
    <div class="pt-3 sm:pt-4">
      <button
        type="submit"
        [disabled]="commentForm.invalid || isLoading()"
        class="w-full bg-yellow-600 text-white py-2 sm:py-3 px-4 sm:px-6 rounded-md text-sm sm:text-base font-medium submit-button focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 disabled:bg-gray-400 disabled:cursor-not-allowed transition-all duration-300"
      >
        @if (isLoading()) {
        <i class="fas fa-spinner fa-spin mr-2"></i>
        <span class="hidden sm:inline">Enviando...</span>
        <span class="sm:hidden">Enviando...</span>
        } @else {
        <i class="fas fa-paper-plane mr-2"></i>
        <span class="hidden sm:inline">Enviar Comentario</span>
        <span class="sm:hidden">Enviar</span>
        }
      </button>
    </div>
  </form>
</div>
